import React from 'react';
import DateHelper from '../DateHelper/DateHelper';
import numeral from "numeral";
import I18n from 'i18n-js';
import DataTable from '../DataTable/DataTable'
import { differenceInDays } from 'date-fns';



export default class ReservationBuilderSegmentSummary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      open: true,

    };
  };




  render() {
    var segment = this.props.segment;
    var billing_policy = this.props.segment.rate.billing_policy;
    var products = this.renderProducts(segment.rate)
    var number_of_nights = differenceInDays(segment.check_out_date, segment.check_in_date)
    return (
      <div className="reservation-segment expanded" ref="reservation_segment" key={segment.id}>
        <div className="header">

          <div className="flexed segment-price-details-wrapper">
            <span className="seg-details-wrapper">
              {!this.props.open ? this.renderArrow() : null}
              {DateHelper.printDateToScreen(segment.check_in_date, this.state.dateFormat)} &ndash; {DateHelper.printDateToScreen(segment.check_out_date, this.state.dateFormat)}  ({number_of_nights} {number_of_nights > 1 ? I18n.t('nights') : I18n.t('night')}, {segment.number_of_guests} {segment.number_of_guests > 1 ? I18n.t('guests') : I18n.t('guest')}): &nbsp;
              <strong><a href={`/admin/room_types/${this.props.segment.room_type.id}`} className="modal-iframe" data-fullscreen="true">{segment.room_type.name}</a> (<a href={`/admin/rates/${segment.rate.id}`} className="modal-iframe" data-fullscreen="true">{segment.rate.code}</a>)</strong>&nbsp;
            </span>
            {/* <div className="seg-price-wrapper" >
              <div>{segment.subtotal_amount ? ' $' + numeral((segment.subtotal_amount - segment.add_ons_subtotal_amount) / 100).format(this.state.numberFormat) : null}</div>
            </div> */}
          </div>
          <div>
            {this.renderAddOns(segment)}
          </div>

          {
            segment.rate.rate_products && segment.rate.rate_products.length
              ?
            <div style={{fontStyle: 'italic', marginLeft: '21px', fontSize: '12px'}}>
              <label>{I18n.t('includes')}:</label>
              <ul>
                {products}
              </ul>
            </div>
              :
            null
          }
        </div>
        {
  
          this.renderFoloItemsTable(segment)

        }

      </div>

    );
  }

  renderFoloItemsTable = (segment) => {
    if(this.state.open){
      return(
        <div className="panel panel-default" ref="body">
          <div className='panel-body container'>
            <div className='table-wrap-panel'>
              <DataTable
                endpoint={this.props.edit_reservation_segment_folio_items_data_table_path ? this.props.edit_reservation_segment_folio_items_data_table_path : `/admin/reservation-segments/${segment.temp_id}/booking-folio-items/data-table`}

                // segment_temp_id = {segm}
                // ids ={this.props.folio_items.map((folio_item) => {return folio_item.id})}
                no_data_text={I18n.t('none')}
                currency_unit={I18n.t('number.currency.format.unit')}
                delimiter={I18n.t('number.currency.format.delimiter')}
                separator={I18n.t('number.currency.format.separator')}
                date_format={this.props.date_format}
                time_format={this.props.time_format}
                read_only={this.props.read_only} />
            </div>
          </div>
        </div>
      );
    };
  };



  renderAddOns(reservation_segment) {
    var self = this;
    var add_ons = []
    if (reservation_segment.reservation_segment_add_ons && self.props.products) {
      for (var i = 0, ilen = reservation_segment.reservation_segment_add_ons.length; i < ilen; i++) {
        var reservation_segment_add_on = reservation_segment.reservation_segment_add_ons[i];

        for (var j = 0, jlen = self.props.products.length; j < jlen; j++) {
          var product = self.props.products[j];
          if (product.id === reservation_segment_add_on.product_id) {
            var quantity = reservation_segment_add_on.quantity
            add_ons.push(
              <tr key={product.id}>
                <td className="segemnt-add-on-name-td">{product.name}{quantity > 1 ? <span> &times; {quantity}</span> : ''}</td>
                <td className="text-right segment-add-on-amount-td">{self.props.currency.symbol}{numeral(reservation_segment_add_on.subtotal_amount * self.props.currency.exchange_rate / 100).format(self.state.numberFormat)}</td>
              </tr>
            );
          };
        };
      };
    };

    if (add_ons && add_ons.length) {
      return (
        <table className="add-ons-table">
          <tbody>
            {add_ons}
          </tbody>
        </table>
      )
    } else {
      return null
    };
  };

  renderArrow() {
    if (this.state.open) {
      return (
        <div className="toggle-arrow arrow-down" onClick={this.onOpenClose}></div>
      );
    } else {
      return (
        <div className="toggle-arrow arrow-right" onClick={this.onOpenClose}></div>
      );
    };
  };

  renderProducts(rate) {
    var products = []
    if (rate.rate_products && rate.rate_products.length) {
      rate.rate_products.map((rate_product) => {
        products.push(
          <li key={rate_product.name}>{rate_product.quantity} {rate_product.name}</li>
        );
      });
    };
    return products;
  };

  onOpenClose=() => {
    this.setState({open: !this.state.open});
  };



};